<!-- =========================================================================================
  File Name: BookEditTabInformation.vue
  Description: Book Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">

        <vs-select class="mt-4 w-full" v-model="bookMetaInfo.metaType" label="데이타 타입" name="metaType" v-validate="'required'">
          <vs-select-item :key="item.key" :value="item.key" :text="item.label" v-for="item in metaTypeOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('metaType')">{{ errors.first('metaType') }}</span>
  
        <vs-input class="w-full mt-4" v-model="bookMetaInfo.metaCode" label="데이타 코드" v-validate="'required'" name="metaCode" placeholder="영문+숫자 조합"/>
        <span class="text-danger text-sm" v-show="errors.has('metaCode')">{{ errors.first('metaCode') }}</span>

        <vs-input class="w-full mt-4" v-model="bookMetaInfo.metaValue" label="데이타 값" v-validate="'required'" name="metaValue" placeholder=""/>
        <span class="text-danger text-sm" v-show="errors.has('metaValue')">{{ errors.first('metaValue') }}</span>

        <vs-input class="w-full mt-4" type="number" v-model="bookMetaInfo.metaOrder" label="순서" v-validate="'required'" name="metaOrder" placeholder=""/>
        <span class="text-danger text-sm" v-show="errors.has('metaOrder')">{{ errors.first('metaOrder') }}</span>

        <vs-select class="mt-4 w-full" v-model="bookMetaInfo.deleteYn" label="사용안함(삭제)" name="deleteYn" v-validate="'required'">
          <vs-select-item :key="item.key" :value="item.key" :text="item.label" v-for="item in deleteYnOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('deleteYn')">{{ errors.first('deleteYn') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">  
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">수정</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { putData } from '@/api/module'

export default {
  components: {
    putData
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return { 
      bookMetaInfo: this.data,
      metaTypeOptions: [
        {
          label: 'Unit',
          key:'UNIT'
        },
        {
          label: 'Step',
          key:'STEP'
        },
        {
          label: 'Menu',
          key:'MENU'
        }
      ],
      deleteYnOptions: [
        {
          label: 'Y',
          key:'Y'
        },
        {
          label: 'N',
          key:'N'
        }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {

    confirmSaveChanges () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '교재 메타정보 수정',
        text: '수정 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '수정'
      })
    },
    async saveChanges () {

      if (!this.validateForm) return
      try {

        const bookSeq = this.bookMetaInfo.bookSeq
        await putData(`/book/${bookSeq}/meta`, this.bookMetaInfo)
        this.$vs.loading.close()

        this.$router.push(`/book/book-view/${bookSeq}`)
      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    
  }
}
</script>
